var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconHome } from "@consta/icons/IconHome";
import { IconMoon } from "@consta/icons/IconMoon";
import { IconQuestion } from "@consta/icons/IconQuestion";
import { IconSettings } from "@consta/icons/IconSettings";
import { IconSun } from "@consta/icons/IconSun";
import { IconTable2 } from "@consta/icons/IconTable2";
import { Breadcrumbs } from "@consta/uikit/Breadcrumbs";
import { Button } from "@consta/uikit/Button";
import { ContextMenu } from "@consta/uikit/ContextMenu";
import { Layout } from "@consta/uikit/Layout";
import { Popover } from "@consta/uikit/Popover";
import { Text } from "@consta/uikit/Text";
import { presetGpnDefault } from "@consta/uikit/Theme";
import { User } from "@consta/uikit/User";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS_VALUES } from "../../enums/routing-paths-values";
import { parseFullUserName } from "../../utils/system/parceFullName";
import { useAuth } from "react-oidc-context";
import { useShallow } from "zustand/react/shallow";
import { useAuthManagerStore } from "../../../core/services/stores/authManagerStore/store";
import { useObjectsStore } from "../../../core/services/stores/objectsStore/store";
import { useThemeStore } from "../../../core/services/stores/themeStore/store";
import { environment } from "../../../environment";
import { ClaimEnum } from "../../enums/claim";
import { HeaderContextItemType } from "../../enums/context-item-type";
import CustomModal from "../CustomModal/CustomModal";
import styles from "./Header.module.scss";
import Feedback from "./components/Feedback/Feedback";
import SignOut from "./components/SignOut/SignOut";
import { CONTEXT_ITEMS } from "./utils/context-items";
var PageName;
(function (PageName) {
    PageName["MAIN"] = "\u0413\u043B\u0430\u0432\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
    PageName["STATISTIC"] = "\u041C\u043E\u0434\u0443\u043B\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0438";
    PageName["CONFIGURATION"] = "\u041C\u043E\u0434\u0443\u043B\u044C \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438";
})(PageName || (PageName = {}));
var DEFAULT_PAGE = [
    {
        label: PageName.MAIN,
        icon: IconHome,
        link: PATHS_VALUES.DIAGRAMS_PAGE,
    },
];
var STATISTIC_SUB_MENU = {
    label: PageName.STATISTIC,
    link: PATHS_VALUES.STATISTIC,
};
var CONFIGURATION_SUB_MENU = {
    label: PageName.CONFIGURATION,
    link: PATHS_VALUES.CONFIGURATION,
};
var STATISTIC_PAGE = [
    {
        label: PageName.STATISTIC,
        icon: IconTable2,
        link: PATHS_VALUES.STATISTIC,
    },
];
var CONFIGURATION_PAGE = [
    {
        label: PageName.CONFIGURATION,
        icon: IconSettings,
        link: PATHS_VALUES.CONFIGURATION,
    },
];
var Header = function () {
    var pathname = useLocation().pathname;
    var auth = useAuth();
    var _a = useThemeStore(useShallow(function (state) { return ({
        switchTheme: state.switchTheme,
        selectedTheme: state.selectedTheme,
    }); })), switchTheme = _a.switchTheme, selectedTheme = _a.selectedTheme;
    var selectedObject = useObjectsStore(function (state) { return state.selectedObject; });
    var _b = useAuthManagerStore(useShallow(function (state) { return ({
        userName: state.userName,
        permissions: state.permissions,
        currentRole: state.currentRole,
    }); })), userName = _b.userName, permissions = _b.permissions, currentRole = _b.currentRole;
    var _c = useState(false), isCreateContextOpen = _c[0], setIsCreateContextOpen = _c[1];
    var _d = useState(DEFAULT_PAGE), items = _d[0], setItems = _d[1];
    var _e = useState(false), userModal = _e[0], setUserModal = _e[1];
    var _f = useState(false), isPopoverVisible = _f[0], setIsPopoverVisible = _f[1];
    var _g = useState(), userModalType = _g[0], setuserModalType = _g[1];
    var anchorRef = useRef(null);
    var userRef = useRef(null);
    var navigate = useNavigate();
    var getSubMenu = function () {
        var subMenu = [];
        if (permissions === null || permissions === void 0 ? void 0 : permissions.includes(ClaimEnum.CanViewStatistic)) {
            subMenu.push(STATISTIC_SUB_MENU);
        }
        if (permissions === null || permissions === void 0 ? void 0 : permissions.includes(ClaimEnum.CanViewConfiguration)) {
            subMenu.push(CONFIGURATION_SUB_MENU);
        }
        return subMenu;
    };
    useEffect(function () {
        var breadCrumbs = [
            __assign(__assign({}, DEFAULT_PAGE[0]), { subMenu: getSubMenu() }),
        ];
        if (pathname.includes(PATHS_VALUES.STATISTIC)) {
            setItems(breadCrumbs.concat(STATISTIC_PAGE));
            return;
        }
        if (pathname.includes(PATHS_VALUES.CONFIGURATION)) {
            setItems(breadCrumbs.concat(CONFIGURATION_PAGE));
            return;
        }
        setItems(breadCrumbs);
    }, [pathname]);
    function signoutHandler() {
        auth.signoutRedirect();
    }
    var handleClickOnQuestion = function () {
        setIsPopoverVisible(!isPopoverVisible);
    };
    var goToPage = function (item) {
        if (item.label === PageName.MAIN) {
            navigate(item.link);
            return;
        }
        var path = "".concat(item.link, "/").concat(selectedObject === null || selectedObject === void 0 ? void 0 : selectedObject.id);
        navigate(path);
    };
    var onSelectContextBtn = function (item) {
        if (item.label === HeaderContextItemType.DOCS) {
            window.open(environment.urlDocs);
            return;
        }
        setUserModal(true);
        setuserModalType(item.label);
        setIsCreateContextOpen(false);
    };
    return (_jsxs(Layout, __assign({ className: styles.header }, { children: [_jsx(Layout, __assign({ className: styles.info }, { children: _jsx(Breadcrumbs, { className: styles.breadCrumbs, size: "m", items: items, onItemClick: function (item) { return goToPage(item); } }) })), _jsxs(Layout, __assign({ className: styles.actions }, { children: [_jsx(Button, { size: "s", view: "clear", onlyIcon: true, iconLeft: IconQuestion, ref: anchorRef, onClick: handleClickOnQuestion }), _jsx(Button, { size: "s", view: "clear", onlyIcon: true, iconLeft: selectedTheme === presetGpnDefault ? IconSun : IconMoon, onClick: function () { return switchTheme(); } }), _jsx(User, { className: styles.user, name: parseFullUserName(userName), info: "".concat(currentRole, " \u041C\u041C \u041F\u0418\u0414"), ref: userRef, onClick: function () { return setIsCreateContextOpen(true); } }), _jsx(ContextMenu, { isOpen: isCreateContextOpen, items: CONTEXT_ITEMS, anchorRef: userRef, getItemLeftIcon: function (item) { return item.imageLeft; }, direction: "downStartLeft", onItemClick: onSelectContextBtn, onClickOutside: function () { return setIsCreateContextOpen(false); } }), _jsx(Layout, { children: _jsx(CustomModal, __assign({ className: styles.modal, isOpened: userModal, closeBtn: _jsx(Button, { size: "s", label: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }), onClose: function () { return setUserModal(false); } }, { children: userModalType === HeaderContextItemType.FEEDBACK ? (_jsx(Feedback, { setUserModal: setUserModal })) : (_jsx(SignOut, { signoutHandler: signoutHandler })) })) })] })), isPopoverVisible && (_jsx(Popover, __assign({ direction: "downCenter", spareDirection: "downStartLeft", offset: "2xs", arrowOffset: 0, onClickOutside: handleClickOnQuestion, isInteractive: true, anchorRef: anchorRef, equalAnchorWidth: false }, { children: _jsx(Layout, __assign({ className: styles.popover }, { children: _jsxs(Text, { children: ["\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F: ", environment.curVersion] }) })) })))] })));
};
export default Header;
